var _defs, _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1159_16222",
    x1: -5.91514e-7,
    y1: 141.55,
    x2: 195.714,
    y2: 124.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#06596E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3B91"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1296 9.73597C90.8894 4.51172 99.1106 4.51173 103.87 9.73598L109.489 15.9029C112.647 19.3686 117.533 20.6779 122.001 19.2554L129.95 16.724C136.684 14.5796 143.804 18.6902 145.314 25.5944L147.096 33.7445C148.098 38.3246 151.675 41.9019 156.256 42.9035L164.406 44.686C171.31 46.196 175.42 53.3158 173.276 60.05L170.745 67.9994C169.322 72.4667 170.631 77.3534 174.097 80.5109L180.264 86.1296C185.488 90.8894 185.488 99.1106 180.264 103.87L174.097 109.489C170.631 112.647 169.322 117.533 170.745 122.001L173.276 129.95C175.42 136.684 171.31 143.804 164.406 145.314L156.256 147.096C151.675 148.098 148.098 151.675 147.096 156.256L145.314 164.406C143.804 171.31 136.684 175.42 129.95 173.276L122.001 170.745C117.533 169.322 112.647 170.631 109.489 174.097L103.87 180.264C99.1106 185.488 90.8894 185.488 86.1296 180.264L80.5109 174.097C77.3534 170.631 72.4667 169.322 67.9994 170.745L60.05 173.276C53.3158 175.42 46.196 171.31 44.686 164.406L42.9035 156.256C41.9018 151.675 38.3246 148.098 33.7445 147.096L25.5944 145.314C18.6902 143.804 14.5795 136.684 16.724 129.95L19.2554 122.001C20.6779 117.533 19.3685 112.647 15.9029 109.489L9.73597 103.87C4.51172 99.1106 4.51173 90.8894 9.73598 86.1296L15.9029 80.5109C19.3686 77.3534 20.6779 72.4667 19.2554 67.9994L16.724 60.05C14.5795 53.3158 18.6902 46.196 25.5944 44.686L33.7445 42.9035C38.3246 41.9018 41.9019 38.3246 42.9035 33.7445L44.686 25.5944C46.196 18.6902 53.3158 14.5795 60.05 16.724L67.9994 19.2554C72.4667 20.6779 77.3534 19.3685 80.5109 15.9029L86.1296 9.73597Z",
    fill: "url(#paint0_linear_1159_16222)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 95,
    cy: 95,
    r: 67,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6 59.8C63.7399 59.8 59.8 63.7399 59.8 68.6V117C59.8 124.29 65.7098 130.2 73 130.2C80.2902 130.2 86.2 124.29 86.2 117V68.6C86.2 63.7399 82.2601 59.8 77.4 59.8H68.6ZM73 121.4C75.43 121.4 77.4 119.43 77.4 117C77.4 114.57 75.43 112.6 73 112.6C70.5699 112.6 68.6 114.57 68.6 117C68.6 119.43 70.5699 121.4 73 121.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 113.667L116.558 92.1095C119.994 88.6729 119.994 83.1011 116.558 79.6644L110.335 73.4419C106.899 70.0053 101.327 70.0053 97.8901 73.4419L95 76.332V113.667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.4 130.2H90.9126L117.313 103.8H121.4C126.26 103.8 130.2 107.74 130.2 112.6V121.4C130.2 126.26 126.26 130.2 121.4 130.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignBadge);
export default __webpack_public_path__ + "static/media/design-badge.d0d94dcc219cd6345cb39991a11e7d84.svg";
export { ForwardRef as ReactComponent };